import {useEffect} from "react";

export const useVrSetup = ({vr, debug, projection, forceCardboard, player}) => {
    useEffect(() => {
        if ( ! player || ! vr) {
            // console.warn('no VR!?');
            return;
        }
        console.info('Restarting VR....', projection);
        player.vr({
            debug, projection, forceCardboard
        });

    }, [vr, debug, projection, forceCardboard, player]);
}
